import { connect } from "react-redux";
import ShootingPlanDrawer from './shooting_plan_drawer'
const mapStateToProps = (state) => ({
    projects: state.entities.projects,
    session: state.session
})

export default connect(mapStateToProps)(ShootingPlanDrawer)